import styled from 'styled-components';
import '../../styles/GlobalThemeStyleCQ';
import Navbar from 'react-bootstrap/Navbar';
import {
	Dropdown,
	Button,
	Avatar,
	Space,
	Breadcrumb,
	Modal,
	Badge,
	Input,
} from 'antd';
import { DownOutlined, BellOutlined } from '@ant-design/icons';
import Container from 'react-bootstrap/Container';

export const XHeaderContainer = styled(Container)`
	/* display: flex;
	justify-content: space-between; */
	background: ${({ theme }) => theme.CQColors.white} !important;
	border-bottom: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	padding: 15px 30px;
	/* margin-left: -200px;
	width: calc(100% + 200px); */
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
`;
export const XThemeDateDays = styled(Space)`
	margin-right: 15px;
	font-weight: 400;
	font-size: 14px;
	line-height: 14px;
	color: ${({ theme }) => theme.colors.themeColor3};
	@media only screen and (max-width: 991.99px) {
		font-size: 16px;
		margin-right: 0px;
		font-weight: 300;
	}
`;
export const HeaderTitle = styled.label`
	color: ${({ theme }) => theme.colors.themeColor1};
	font-family: ${({ theme }) => theme.colors.fontPoppins};
	font-style: normal;
	font-size: 18px;
	line-height: 20px;
	font-weight: 600;
	span {
		font-weight: 300;
	}
`;

export const XNavbar = styled(Navbar)`
	background: transparent;
	@media only screen and (max-width: 1199.99px) {
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 9999;
		padding: 15px 0px;
		background-color: rgba(255, 255, 255, 0.5);
		box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
		backdrop-filter: blur(10px);
	}

	.centerMenuSpace {
		margin: 0px 15px;
	}
	.navbar-toggler {
		border: none;
		outline: none;
		box-shadow: none;
		color: #212226;
		@media only screen and (max-width: 768.99px) {
			float: right;
		}
	}
`;
export const XSpace = styled(Space)`
	color: ${({ theme }) => theme.colors.menu1};
`;
export const XSpaceNotif = styled(Space)`
	color: ${({ theme }) => theme.colors.menu1};
	margin-left: 30px;
	height: 30px;
`;
export const XDownOutlined = styled(DownOutlined)`
	margin-top: 5px;
	color: ${({ theme }) => theme.colors.menu1};
	font-size: 10px;
`;
export const XBellOutlined = styled(BellOutlined)`
	margin-left: 30px;
	margin-top: 5px;
	color: ${({ theme }) => theme.colors.menu1};
	font-size: 20px;
`;
export const XDropdown = styled(Dropdown)`
	a {
		text-decoration: none;
	}
`;
export const XButton = styled(Button)`
	background: transparent;
`;
export const XAvatar = styled(Avatar)`
	background: none;
	cursor: pointer;
`;
export const XBreadcrumb = styled(Breadcrumb)`
	font-weight: 400;
	font-size: 14px;
	line-height: 14px;
	color: #212226;
	position: absolute;
	bottom: -23px;
	.ant-breadcrumb-link {
		color: #007299;
	}
`;
export const XUpdateModal = styled(Modal)`
	.ant-modal-title {
		font-style: normal;
		font-weight: 500 !important;
		font-size: 18px !important;
		color: ${({ theme }) => theme.CQColors.primaryColor} !important;
	}
	.modalCard {
		width: 100%;
		position: relative;
		background: ${({ theme }) => theme.CQColors.white};
		border: 1px solid rgba(87, 99, 111, 0.15);
		border-radius: 10px;
		padding: 15px;
	}
	.cardImgBg {
		border-radius: 40px;
		width: 50px;
		height: 50px;
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		text-align: center;
		line-height: 50px;
		svg,
		img {
			margin-top: -2px;
			filter: ${({ theme }) => theme.CQColors.imgFilterWhite};
		}
	}
	h6 {
		margin: 0px;
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: ${({ theme }) => theme.CQColors.themeColor3};
	}
	h4 {
		margin: 0px;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.primaryColor};
	}
`;

export const XBadge = styled(Badge)`
	font-size: 20px;
	padding: 0px;
	cursor: pointer;
	.ant-badge-count {
		background-color: ${({ theme }) => theme.CQColors.themeColor1};
	}
`;
export const XThem2Search = styled(Input)`
	background-color: ${({ theme }) => theme.CQColors.white};
	border-radius: 10px !important;
	&:hover,
	&:focus,
	&:active,
	&:focus-visible,
	&:focus-within {
		border-color: ${({ theme }) => theme.CQColors.borderColor};
	}
	svg {
		color: ${({ theme }) => theme.CQColors.themeColor6};
	}
	button {
		background: transparent;
		border-radius: 0px;
		&:hover {
			background: transparent !important;
		}
	}
`;
export const XDateTime = styled.span`
	font-family: ${({ theme }) => theme.CQColors.fontInter};
	font-size: 14px;
	font-weight: 500;
	line-height: 18px;
	color: ${({ theme }) => theme.CQColors.themeColor3};
	margin-right: 15px;
`;
